export const SET_CONTEXT = 'jira/SET_CONTEXT';
export const FATAL_ERROR = 'jira/FATAL_ERROR';
export const ON_MODAL_CLOSED = 'jira/ON_MODAL_CLOSED';

export const setContext = (context, settings, session) => ({
  type: SET_CONTEXT,
  context,
  settings,
  session
});

export const fatalError = (error) => ({
  type: FATAL_ERROR,
  error,
});

export const onModalClosed = (url) => ({
  type: ON_MODAL_CLOSED,
  url,
});
